import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Statistics } from "@app/core/statistics/domain/model/statistics";
import { StatisticsMapper } from "@app/core/statistics/data/network/mapper/statistics.mapper";
import { StatisticsSearchCriteria } from "@app/core/statistics/domain/statistics-search-criteria";
import { StatisticsSearchCriteriaMapper } from "@app/core/statistics/data/network/statistics-search-criteria.mapper";

/**
 * Sample WS to get the sample user's general statistics. Sends token if
 * available.
 */
@Injectable({
  providedIn: "root",
})
export class AggregateStatisticsSampleWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    statisticsSearchCriteria: StatisticsSearchCriteria,
    token: string | null
  ): Observable<Statistics> {
    const builder = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.SAMPLE_AGGREGATE_STATISTICS_ENDPOINT())
      .setUrlParams(
        StatisticsSearchCriteriaMapper.serialize(statisticsSearchCriteria)
      );
    if (token != null) {
      builder.setAuthorization(new TokenAuthorization(token));
    }
    return this.baseHandler
      .execute(builder.build())
      .pipe(map((response) => StatisticsMapper.deserialize(response)));
  }
}
